<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

        <trax-ui-select icon="location_on" v-model="form.entity_id" :options="locations_select" grouped="1"
            :unselected="lang.polaris.common.no_location">
        </trax-ui-select>

        <trax-ui-select icon="insert_photo" v-model="form.meta.background" :options="backgrounds_select">
        </trax-ui-select>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            toastrId: null,
            endpoint: null,
        },
    
        data: function() {
            return {
                lang: lang,
                form: {
                    meta: {}
                },
                errors: {},
                locations_select: data.locations_select,
                backgrounds_select: data.backgrounds_select,
                props: {
                    id: { source:'id' },
                    type: { source:'type', default: 'enac-atpl-phase' },
                    name: { source:'name' },
                    description: { source:'description' },
                    order: { source:'order' },
                    entity_id: { source:'entity_id' },
                    location: { source:'location' },
                    meta: { source: this.meta },
                },
                titles: {
                    new: lang.polaris.common.new_phase,
                    update: lang.polaris.common.phase_update
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        },

        methods: {
            
            meta(data) {
                return Array.isArray(data.meta) ? {} : data.meta
            }
        }
    }
</script>
